import RNSecureStorage from 'react-secure-storage';

export const setNukeTime = (time: string) => RNSecureStorage.setItem('nuke_time', time);

export const retrieveNukeTime = () => RNSecureStorage.getItem('nuke_time');
